import { render } from "./FormationTag.vue?vue&type=template&id=32b36d6d"
import script from "./FormationTag.vue?vue&type=script&lang=js"
export * from "./FormationTag.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__